export default "__VITE_ASSET__Cawkdo0q__"